import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { EndasureEmailComponent } from '../../endasure/endasure-email/endasure-email.component';
import { ViewportScroller } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';
import { Subscription, take, takeUntil } from 'rxjs';
import { KbsmartireEmailComponent } from '../kb-smarttire-email/kbsmartire-email/kbsmartire-email.component';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'app-smarttire-savings-info',
  templateUrl: './smarttire-savings-info.component.html',
  styleUrl: './smarttire-savings-info.component.scss',
  standalone: false
})
export class SmarttireSavingsInfoComponent implements OnDestroy {
  tableData: any[];
  subscription = new Subscription();
  results: {
    res1_norm: number;
    res1_smar: number;
    res1_save: number;
    res2_norm: number;
    res2_smar: number;
    res2_save: number;
    res3_norm: number;
    res3_smar: number;
    res3_save: number;
    res4_norm: number;
    res4_smar: number;
    res4_save: number;
    tot_norm: number;
    tot_smar: number;
    tot_save: number;
    tot_anual: number;
  };
  constructor(public SmartTireService: SmartTireService, private cdr: ChangeDetectorRef,
    private matdialog: MatDialog, private viewPortScroller: ViewportScroller,
    private globalmsgService: GlobalMessageService,
  ) {
    this.SmartTireService.TableCalculation();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  endurasureSummaryForm = new FormGroup({});
  get form() {
    return this.endurasureSummaryForm.controls;
  }


  endaSureBack() {
    this.SmartTireService.currentComponent$.next('maintaince');
    this.cdr.detectChanges();
  }
  ngOnInit() {

    this.subscription.add(this.SmartTireService.savingsData$.subscribe(x => {
      this.tableData = x;
      console.log('tableData', this.tableData);
      this.cdr.detectChanges();
    }));

    this.subscription.add(this.SmartTireService.roiReduce$.pipe()
      .subscribe(data => {
        console.log('roiReduce', data);
        if (data != null) {
          this.roiReduceForm.patchValue({
            roiReduce: data.roi_reduce || 40,
          })
          this.SmartTireService.TableCalculation();
        }
      }));

  }
  roiReduceForm = new FormGroup({
    roiReduce: new FormControl(40),

  });
  emailPopup() {
    this.viewPortScroller.scrollToPosition([0, 0]);
    this.matdialog.open(KbsmartireEmailComponent).afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result?.status === 'Success') {
          this.globalmsgService.add(
            { key: result.message },
            GlobalMessageType.MSG_TYPE_INFO
          );
        }
      });
  }
  resetForms() {
    this.SmartTireService.triggerReset();
    this.SmartTireService.currentComponent$.next('visitorInfo');
  }
  CurrencyFormatted(amount: number): string {
    if (amount != null || undefined) {
      // Round to 2 decimal places
      const roundedAmount = amount.toFixed(2);

      // Add commas for thousands separator
      const parts = roundedAmount.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Join the parts and return
      return parts.join('.');
    } else {
      return '';
    }
  }
}
